export const TOMO_KEYWORDS = ['tomo', 'dbt', 'tomosynthesis', 'breast tomosynthesis', 'bto'];

const lower = (value) => (value || '').toString().toLowerCase();

export const seriesText = (series = {}) => [
  series.seriesDescription,
  series.protocolName,
  series.bodyPartExamined,
  series.modality,
  series.laterality,
  series.imageLaterality,
  series.viewPosition,
].filter(Boolean).map(lower).join(' ');

export const isMammographyTomoSeries = (series = {}) => {
  const modality = String(series.modality || '').trim().toUpperCase();
  const text = seriesText(series);
  return modality === 'MG' && TOMO_KEYWORDS.some(keyword => text.includes(keyword));
};

export const knownInstanceCount = (series = {}) => {
  const knownCount = Number.parseInt(series.numInstances ?? series.num_instances ?? series.instanceCount, 10);
  return Number.isFinite(knownCount) && knownCount > 0 ? knownCount : null;
};

export const preferredInitialSlice = (series = {}, count = 1) => {
  const safeCount = Math.max(Number.isFinite(Number(count)) ? Math.floor(Number(count)) : 1, 1);
  const maxSlice = Math.max(safeCount - 1, 0);
  const requested = Number.parseInt(
    series._kairosInitialSlice ?? series.initialSlice ?? series.initial_slice ?? series.startSlice ?? series.start_slice,
    10
  );
  if (Number.isFinite(requested) && requested >= 0) {
    return Math.max(0, Math.min(maxSlice, requested));
  }
  return Math.floor(maxSlice / 2);
};

export const shouldFetchRenderedSeriesCount = (series = {}) => {
  const count = knownInstanceCount(series);
  if (!count) return true;
  // Breast tomosynthesis is commonly encoded as one Enhanced MG instance with many frames.
  // QIDO/Search "NumberOfSeriesRelatedInstances" can therefore be 1 even though the
  // renderer exposes a scrollable frame stack. Ask the renderer for authoritative count.
  if (isMammographyTomoSeries(series)) return true;
  return false;
};

export const resolveDisplayFrameCount = async (series, getSeriesCount) => {
  if (!shouldFetchRenderedSeriesCount(series)) return knownInstanceCount(series);
  const renderedCount = await getSeriesCount(series.studyInstanceUID, series.seriesInstanceUID);
  return renderedCount || knownInstanceCount(series) || 1;
};
